var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateSuccessGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#9A9A9A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.18 0.071)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10.8,
    cy: 10.9,
    r: 11
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.61 6.877)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.5,9.2c-0.3,0-0.5-0.1-0.7-0.3l-3.5-3.5c-0.4-0.4-0.4-1.1,0-1.5c0.4-0.4,1.1-0.4,1.5,0l3.5,3.5 c0.4,0.4,0.4,1.1,0,1.5C4,9.1,3.7,9.2,3.5,9.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.5,9.2C3.2,9.2,3,9.1,2.8,8.9c-0.4-0.4-0.5-1-0.1-1.5l6.9-8.1c0.4-0.4,1-0.5,1.5-0.1 c0.4,0.4,0.5,1,0.1,1.5L4.3,8.8C4.1,9,3.8,9.2,3.5,9.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateSuccessGray);
export default __webpack_public_path__ + "static/media/UpdateSuccessGray.5148e95555b833d0c96636908e8aaf2a.svg";
export { ForwardRef as ReactComponent };